export enum SCROLL_DIRECTION {
    BACKWARD = -1,
    FORWARD = 1,
}

export const SCROLLING_RESET_TIME_INTERVAL = 150;
